module.exports = __webpack_public_path__ + "img/About Icon - charcoal.348d5bc0.svg";